export default "__VITE_ASSET__DL85BTGW__"